import { RouterProvider } from 'react-router-dom';

import { routerAdvertiserApp, routerAdvPubApp, routerPublisherApp } from 'app/router';
import { useAppConfigRetrieveQuery } from 'shared/api';
import { AppLoadingPage } from 'shared/ui';
import { getOneTimeLoginToken, getOneTimeLoginTokenPayload, keycloak } from 'shared/utils';

export const MainLayout = () => {
	const { data: appConfig, isLoading, isSuccess } = useAppConfigRetrieveQuery();

	const otlToken = getOneTimeLoginToken();
	if (otlToken) {
		console.log('Token parsed:', getOneTimeLoginTokenPayload());
	} else {
		console.log('Authenticated:', keycloak?.authenticated);
		console.log('Token:', keycloak?.token);
		console.log('Token parsed:', keycloak?.tokenParsed);
		console.log('User profile:', keycloak?.profile);
	}

	if (isLoading) {
		return <AppLoadingPage />;
	}
	if (isSuccess) {
		const roles = appConfig?.user?.roles;
		const isAdvertiserApp = !roles?.includes('contractor') && roles?.includes('client');
		const isPublisherApp = roles?.includes('contractor') && !roles?.includes('client');
		const appRouter = isAdvertiserApp ? routerAdvertiserApp : isPublisherApp ? routerPublisherApp : routerAdvPubApp;
		return <RouterProvider router={appRouter} />;
	}
};
